module.exports = __webpack_public_path__ + "img/ea32c6e.svg";